import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/699dbc05f782d500145e3874/scaledout/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699dbc05f782d500145e3874/scaledout/src/app/about/components/AboutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699dbc05f782d500145e3874/scaledout/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699dbc05f782d500145e3874/scaledout/src/components/ui/AppLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699dbc05f782d500145e3874/scaledout/src/components/WhatsAppButton.tsx");
